module.exports = __webpack_public_path__ + "img/profile-image-default.b10e5346.svg";